import Avatar from 'components/Avatar';
import { UserCard } from 'components/Card';
import React from 'react';
import {
  MdClearAll,
  MdExitToApp,
  MdSettingsApplications,
} from 'react-icons/md';
import {
  Button,
  ListGroup,
  ListGroupItem,
  // NavbarToggler,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from 'reactstrap';
import bn from 'utils/bemnames';
import {connect} from 'react-redux';
import {logout} from '../../actions/auth'
import {Link} from 'react-router-dom'
const bem = bn.create('header');


class Header extends React.Component {
  state = {
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false,
  };

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  logout = () =>{
    this.props.logout();
  }

  changePassword = () => {
    this.setState({
      redirectToChangePassword:true,
    })
  }

  render() {
    const {user} = this.props;
    let userCardtittle = "Usuario";
    let userCardSubtitle = "";
    if(user){
      if (user.first_name && user.last_name){
        userCardtittle = `${user.first_name} ${user.last_name}`;
      } else {
        userCardtittle = user.username;
      }
      if(user.email){
        userCardSubtitle = user.email;
      }
    }

    return (
      <Navbar light expand className={bem.b('bg-white')}>
        <Nav navbar className="mr-2">
          <Button color='primary' outline onClick={this.handleSidebarControlButton}>
            <MdClearAll size={25} />
          </Button>
        </Nav>
        <Nav navbar>
          {/*<SearchInput /> */}
          SISTEMA DE MONITOREO Y CONTROL DE VIAJES DE FLOTA
        </Nav>

        <Nav navbar className={bem.e('nav-right')}>
          <NavItem>
            <NavLink id="Popover2">
              <Avatar
                onClick={this.toggleUserCardPopover}
                className="can-click"
              />
            </NavLink>
            <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover}
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 250 }}
            >
              <PopoverBody className="p-0 border-light">
                <UserCard
                  title={userCardtittle}
                  subtitle={userCardSubtitle}
                  text=""
                  className="border-light"
                >
                  <ListGroup flush>
                    <ListGroupItem tag="button" action className="border-light" onClick={this.changePassword}>
                      <Link to="/change_password"><MdSettingsApplications /> Cambiar Contraseña</Link>
                    </ListGroupItem>
                    <ListGroupItem tag="button" action className="border-light text-primary" onClick={this.logout}>
                      <MdExitToApp /> Salir
                    </ListGroupItem>
                  </ListGroup>
                </UserCard>
              </PopoverBody>
            </Popover>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}

const mapStateToProps = state => ({
  user:state.auth.user
});

export default connect(mapStateToProps, {logout})(Header);
